import React from "react";
import { Box, TextField } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicTextarea = () => {
  return (
    <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
      <PreviewAndEditor
        title={"Basic TextArea"}
        language={"js"}
        value={
          "     <TextField\n" +
          "          multiline\n" +
          "          minRows={3}\n" +
          '          maxRows={"4"}\n' +
          "        />\n" +
          "\n" +
          "        <TextField\n" +
          '          placeholder="Something about myself"\n' +
          "          multiline\n" +
          "          minRows={3}\n" +
          "          maxRows={4}\n" +
          "        />\n" +
          "\n" +
          "        <TextField\n" +
          "          multiline\n" +
          "          minRows={3}\n" +
          "          maxRows={4}\n" +
          '          value={"Something about myself"}\n' +
          "        />"
        }
      >
        <TextField
          multiline
          minRows={3}
          maxRows={"4"}
          size={"small"}
        />

        <TextField
          multiline
          minRows={3}
          maxRows={4}
          placeholder="Something about myself"
        />

        <TextField
          multiline
          minRows={3}
          maxRows={4}
          value={"Something about myself"}
        />
      </PreviewAndEditor>
    </Box>
  );
};

export default BasicTextarea;
